import { render, staticRenderFns } from "./PrivateKeyModal.vue?vue&type=template&id=5bf337e9&scoped=true&"
import script from "./PrivateKeyModal.vue?vue&type=script&lang=js&"
export * from "./PrivateKeyModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivateKeyModal.vue?vue&type=style&index=0&id=5bf337e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf337e9",
  null
  
)

export default component.exports